var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLikeDisabledIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.2002 0.936035C24.7606 0.936035 31.7002 7.87562 31.7002 16.436C31.7002 24.9964 24.7606 31.936 16.2002 31.936C7.63978 31.936 0.700195 24.9964 0.700195 16.436C0.700195 7.87562 7.63978 0.936035 16.2002 0.936035Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2002 0.936035C24.7606 0.936035 31.7002 7.87562 31.7002 16.436C31.7002 24.9964 24.7606 31.936 16.2002 31.936C7.63978 31.936 0.700195 24.9964 0.700195 16.436C0.700195 7.87562 7.63978 0.936035 16.2002 0.936035Z",
    stroke: "#D9DCE1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.8667 16.4362C7.8667 15.5157 8.61289 14.7695 9.53337 14.7695C10.9141 14.7695 12.0334 15.8888 12.0334 17.2695V20.6029C12.0334 21.9836 10.9141 23.1029 9.53337 23.1029C8.61289 23.1029 7.8667 22.3567 7.8667 21.4362V16.4362Z",
    stroke: "#ADB3BD",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0988 12.5246L18.8769 13.2413C18.6951 13.8286 18.6041 14.1223 18.6741 14.3542C18.7306 14.5418 18.8548 14.7036 19.024 14.81C19.2332 14.9415 19.5496 14.9415 20.1825 14.9415H20.5191C22.6608 14.9415 23.7317 14.9415 24.2375 15.5755C24.2953 15.6479 24.3467 15.7249 24.3912 15.8058C24.7803 16.5128 24.3379 17.4653 23.4532 19.3703C22.6413 21.1184 22.2353 21.9925 21.4816 22.507C21.4086 22.5568 21.3336 22.6038 21.2568 22.6478C20.4632 23.1027 19.48 23.1027 17.5135 23.1027H17.087C14.7046 23.1027 13.5134 23.1027 12.7733 22.3856C12.0332 21.6685 12.0332 20.5143 12.0332 18.206V17.3947C12.0332 16.1816 12.0332 15.575 12.2485 15.0199C12.4638 14.4647 12.876 14.0082 13.7004 13.0953L17.11 9.31984C17.1955 9.22515 17.2382 9.1778 17.2759 9.14499C17.6278 8.83877 18.1709 8.87324 18.4785 9.22132C18.5115 9.25861 18.5475 9.31096 18.6195 9.41565C18.7322 9.57941 18.7886 9.66129 18.8377 9.74241C19.2772 10.4686 19.4102 11.3313 19.2089 12.1503C19.1864 12.2418 19.1572 12.3361 19.0988 12.5246Z",
    stroke: "#ADB3BD",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLikeDisabledIcon);
export default __webpack_public_path__ + "static/media/like-disabled-icon.1703cc38afc767c4984689e711119427.svg";
export { ForwardRef as ReactComponent };